import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogService} from "@shared/services/dialog-service";
import { SpreadsheetState } from '../store/spreadsheet.reducer';
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';
import {execute} from 'ng-packagr';


@Injectable({
  providedIn: 'root',
})

export class RemoveDataExtractorMappingCommandHandler implements IPlatformCommandHandler {
  constructor(
    protected dialogService: DialogService
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    this.dialogService.showConfirmDialog('Warning!', 'Ok', 'Cancel', command.fieldValues['WarningMessage'], '').subscribe(state => {
      if (state.action === 'OK') {
        handler.executeCommand(command);
      }
    });
    return true;
  }
}
